import React, { useEffect, useState, FC } from 'react'
import { hot } from 'react-hot-loader/root'
import { Modal } from 'antd'
import { useHistory } from 'react-router-dom'
import { observer } from 'mobx-react'
import { AppStore } from 'src/pc/store/AppStore'
import { getWarorderEligibleHttp, startWarorderHttp } from 'src/commons/store/GameStore'
import { checkNextModal } from 'src/pc/store/UIController'
import styled from '@emotion/styled'
import bg from 'src/pc/assets/images/active-war-order/modal-bg2.png'
import btnBg from 'src/pc/assets/images/active-war-order/btn-bg.png'
import active1CloseImg from 'src/pc/assets/images/active1Close.png'
import { getPhpToken } from '../utils/auth'

/**
 *
 * @description 战令活动弹窗
 */
const ActiveWarOrderModal: FC = () => {
  const history = useHistory()
  const toActive1 = async () => {
    await startWarorderHttp.Execute({ activityNo: 'AT5713210679241831190' })
    AppStore.activeWarOrderVisible = false
    history.push('/activeWarOrder?needDraw=1')
  }

  return (
    <StyledActiveModal footer={false} width={685} visible={AppStore.activeWarOrderVisible}>
      <StyledActiveContainer onClick={toActive1}>
        <StyledBtn>立即参与</StyledBtn>
      </StyledActiveContainer>
    </StyledActiveModal>
  )
}

export const checkUserIsHaveQualification = async () => {
  try {
    const res = await getWarorderEligibleHttp.Execute({ activityNo: 'AT5713210679241831190' })
    if (res && getPhpToken()) {
      window.gogReport?.('Order_PopupWindow_view')
      AppStore.activeWarOrderVisible = true
    }
    return res
  } catch (error) {
    return false
  }
}
const StyledBtn = styled.div`
  cursor: pointer;
  background: url(${btnBg});
  background-size: cover;
  width: 209px;
  height: 54px;
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
  color: #35170d;
  &:hover {
    filter: brightness(1.1);
  }
`
const StyledActiveCloseBtn = styled.div`
  width: 130px;
  height: 104px;
  background: url(${active1CloseImg}) no-repeat;
  background-size: 100% 100%;
  background-position: center center;
  position: absolute;
  top: 8px;
  right: -20px;
  cursor: pointer;
  &:hover {
    filter: brightness(1.1);
  }
`

const StyledActiveContainer = styled.div`
  height: 416px;
  width: 685px;
  cursor: pointer;
`

const StyledActiveModal = styled(Modal)`
  .ant-modal-content {
    background: transparent;
  }
  .ant-modal-body {
    padding: 0;
    background: url(${bg}) no-repeat;
  }
  .ant-modal-close {
    display: none;
  }
`

export default hot(observer(ActiveWarOrderModal))
